import React from "react";

export default class SamsungTest extends React.Component {
  
  state = {
    status:[],

  };

  loadStatus = async () => {
    const {_resolvers} = this.props;
    var data = await _resolvers({...this.props, LookUpValue: true, GetStatus: true})
    var options = [];
    if (data.status === 200)
    {
        data.data.map((e) => {
            options.push({value: e.ShortName, label: e.ShortName})
            this.setState({status: options});
        })
        
    } 
  } 

  componentDidMount() {
    const {_icon} = this.props;
    this.props.setHeaderPage({
      Icon: <_icon facodebranch className="c-placeholder c-green" />,
      Title: "Samsung Integrace",
      SubTitle: "Kompletní integrace s IGSPN",
    });
    this.loadStatus();
  }

  render() {
    const { Bs, VARIANT } = this.props;
    return (
      <>
        <Bs row>
            <Bs col xs={6}>
                <Bs brtxselect options={this.state.status} />
            </Bs>
            <Bs col xs={6}>
                <Bs formcontrol />
            </Bs>
            <Bs col xs={6} className="d-flex justify-content between">
                <Bs formtext>Status</Bs>
            </Bs>
            <Bs col xs={6} className="d-flex justify-content between">
                <Bs formtext>Zakázka</Bs>
            </Bs>
        </Bs>
      </>
    );
  }
}
